export default {"src":"/pro/_next/static/media/meme.d46d588a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};